import React from 'react';
import { SectionTitle } from '@yuhuinc/ui-library';
import { Button, Form, Space, Typography } from 'antd';
import AssociationGroupDrawer from './AssociationGroupDrawer';
import { useDrawerState } from 'ui-library';
import { getTranslatedString } from 'helpers/i18n';
import AssociationGroupsTable from './AssociationGroupsTable';
const { Text } = Typography;

const atLeastOneAssociationRule = {
  required: true,
  message: getTranslatedString('landlordPortal.incentives.atLeastOneAssociation'),
};

const AssociationGroups = () => {
  const [, associationGroupDrawer] = useDrawerState(false);

  return (
    <Space direction="vertical" size="middle">
      <Space direction="vertical" size="small">
        <SectionTitle>
          {getTranslatedString('landlordPortal.incentives.associationGroups')}
        </SectionTitle>
        <Text>{getTranslatedString('landlordPortal.incentives.assignThisIncentive')}</Text>
      </Space>

      <Form.List name="association_groups" rules={[atLeastOneAssociationRule]}>
        {(fields, operations, { errors }) => {
          return (
            <Space direction="vertical" size="middle">
              {fields.length > 0 && (
                <AssociationGroupsTable values={fields} operations={operations} />
              )}

              <div>
                <Button type="secondary" onClick={associationGroupDrawer.open}>
                  {getTranslatedString('landlordPortal.incentives.addAssociationGroup')}
                </Button>
              </div>

              <Form.ErrorList errors={errors} />

              <AssociationGroupDrawer drawer={associationGroupDrawer} onAdd={operations.add} />
            </Space>
          );
        }}
      </Form.List>
    </Space>
  );
};

export default AssociationGroups;
